/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'triangle-down': {
    width: 8,
    height: 6,
    viewBox: '0 0 8 6',
    data: '<path pid="0" d="M5.042 5.365l2.854-4.108A.8.8 0 007.24 0H1.53a.8.8 0 00-.657 1.257l2.855 4.108a.8.8 0 001.314 0z" _fill="#213F6B" fill-rule="evenodd"/>'
  }
})
